/**
 * Integration descriptions are shared by both products. Keep the source copy
 * intact for Bustly Core and apply the product name only in Plugin Admin.
 */
export const getIntegrationProductCopy = (
    copy: string,
    usePluginProductCopy: boolean,
): string => (
    usePluginProductCopy ? copy.replaceAll('Bustly', 'BizSidekick') : copy
);
